import { Component, Directive, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { DemandOverviewDataService, DemandOverviewReach } from '../../../../services/demand-overview-data.service';
import { BehaviorSubject } from 'rxjs';
import { NgbdSortableHeader, compare, SortEvent } from 'src/app/modules/shared/directives/sort/sort.directive';

@Component({
  selector: 'app-demand-overview-table',
  templateUrl: './demand-overview-table.component.html',
  styleUrls: ['./demand-overview-table.component.scss']
})
export class DemandOverviewTableComponent {

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  // The behaviour subject for the current API data
  demandOverviewData: DemandOverviewReach[];

  // The behaviour subject for the current SORTED data
  private demandReachesSource = new BehaviorSubject<DemandOverviewReach[]>([]);
  currentDemandReaches = this.demandReachesSource.asObservable();

  direction: string;
  column: string;

  constructor(private demandOverview: DemandOverviewDataService) {}

  ngOnInit(){

    // Getting data from DemandReductionDataService
    this.demandOverview.currentDemandOverview.subscribe(demandOverviewData => {
      this.demandOverviewData = demandOverviewData;
      this.changeDemandReaches(demandOverviewData);
    });

  }

  // Sorting function
  onSort({column, direction}: SortEvent) {
    this.column = column;
    this.direction = direction;

    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting columns
    if (direction === '') {
      this.changeDemandReaches(this.demandOverviewData);
    } else {
      let sortedData = [...this.demandOverviewData].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
      this.changeDemandReaches(sortedData);
    }
  }

  // Update DemandReaches BehaviorSubject
  changeDemandReaches(demandReaches) {
    this.demandReachesSource.next(demandReaches);
  }

}